// Rune icons
import dominationIcon from "../assets/images/leagueoflegends/champions/reforged/domination/0.png"
import resolveIcon from "../assets/images/leagueoflegends/champions/reforged/resolve/0.png"
import sorceryIcon from "../assets/images/leagueoflegends/champions/reforged/sorcery/0.png"
import inspirationIcon from "../assets/images/leagueoflegends/champions/reforged/inspiration/0.png"
import precisionIcon from "../assets/images/leagueoflegends/champions/reforged/precision/0.png"
// Rank Icons
import ironIcon from "../assets/images/dashboard/league-ad-section/iron.png"
import bronzeIcon from "../assets/images/dashboard/league-ad-section/bronze.png"
import silverIcon from "../assets/images/dashboard/league-ad-section/silver.png"
import goldIcon from "../assets/images/dashboard/league-ad-section/gold.png"
import platIcon from "../assets/images/dashboard/league-ad-section/plat.png"
import diamondIcon from "../assets/images/dashboard/league-ad-section/diamond.png"
import masterIcon from "../assets/images/dashboard/league-ad-section/master.png"
import grandmasterIcon from "../assets/images/dashboard/league-ad-section/grandmaster.png"
import challengerIcon from "../assets/images/dashboard/league-ad-section/challenger.png"
// Rank thumbnails
import ironThumbnail from "../assets/images/dashboard/league-ad-section/iron-thumbnail.png"
import bronzeThumbnail from "../assets/images/dashboard/league-ad-section/bronze-thumbnail.png"
import silverThumbnail from "../assets/images/dashboard/league-ad-section/silver-thumbnail.png"
import goldThumbnail from "../assets/images/dashboard/league-ad-section/gold-thumbnail.png"
import platThumbnail from "../assets/images/dashboard/league-ad-section/plat-thumbnail.png"
import diamondThumbnail from "../assets/images/dashboard/league-ad-section/diamond-thumbnail.png"
import masterThumbnail from "../assets/images/dashboard/league-ad-section/master-thumbnail.png"
import grandmasterThumbnail from "../assets/images/leagueoflegends/rank/grandmaster.png"
import challengerThumbnail from "../assets/images/leagueoflegends/rank/challenger.png"
// Onboarding tier thumbnails
import ironOnboardingThumbnail from "../assets/images/onboarding/leagueoflegends/tier_thumbnail/iron.jpg"
import bronzeOnboardingThumbnail from "../assets/images/onboarding/leagueoflegends/tier_thumbnail/bronze.jpg"
import silverOnboardingThumbnail from "../assets/images/onboarding/leagueoflegends/tier_thumbnail/silver.jpg"
import goldOnboardingThumbnail from "../assets/images/onboarding/leagueoflegends/tier_thumbnail/gold.jpg"
import platinumOnboardingThumbnail from "../assets/images/onboarding/leagueoflegends/tier_thumbnail/platinum.jpg"
import diamondOnboardingThumbnail from "../assets/images/onboarding/leagueoflegends/tier_thumbnail/diamond.jpg"
import masterOnboardingThumbnail from "../assets/images/onboarding/leagueoflegends/tier_thumbnail/master.jpg"
// Specialization icons
import top from "@/assets/images/icons/specializations/leagueoflegends/top.svg"
import mid from "@/assets/images/icons/specializations/leagueoflegends/mid.svg"
import jungle from "@/assets/images/icons/specializations/leagueoflegends/jungle.svg"
import bot from "@/assets/images/icons/specializations/leagueoflegends/bot.svg"
import support from "@/assets/images/icons/specializations/leagueoflegends/support.svg"

export const RUNE_PAGE_ICON = {
  domination: dominationIcon,
  resolve: resolveIcon,
  sorcery: sorceryIcon,
  inspiration: inspirationIcon,
  precision: precisionIcon,
}

export const RANK_ICON = {
  iron: ironIcon,
  bronze: bronzeIcon,
  silver: silverIcon,
  gold: goldIcon,
  platinum: platIcon,
  diamond: diamondIcon,
  master: masterIcon,
  grandmaster: grandmasterIcon,
  grand: grandmasterIcon,
  challenger: challengerIcon,
}

export const LEAGUE_RANK_ICONS = {
  iron: {
    i: ironIcon,
    ii: ironIcon,
    iii: ironIcon,
    iv: ironIcon,
  },
  bronze: {
    i: bronzeIcon,
    ii: bronzeIcon,
    iii: bronzeIcon,
    iv: bronzeIcon,
  },
  silver: {
    i: silverIcon,
    ii: silverIcon,
    iii: silverIcon,
    iv: silverIcon,
  },
  gold: {
    i: goldIcon,
    ii: goldIcon,
    iii: goldIcon,
    iv: goldIcon,
  },
  platinum: {
    i: platIcon,
    ii: platIcon,
    iii: platIcon,
    iv: platIcon,
  },
  diamond: {
    i: diamondIcon,
    ii: diamondIcon,
    iii: diamondIcon,
    iv: diamondIcon,
  },
  master: grandmasterIcon,
  grandmaster: grandmasterIcon,
  challenger: challengerIcon,
}

export const RANK_ICON_THUMBNAIL = {
  iron: ironThumbnail,
  bronze: bronzeThumbnail,
  silver: silverThumbnail,
  gold: goldThumbnail,
  platinum: platThumbnail,
  diamond: diamondThumbnail,
  master: masterThumbnail,
  grandmaster: grandmasterThumbnail,
  grand: grandmasterThumbnail,
  challenger: challengerThumbnail,
}

export const NEXT_RANK = {
  iron: "bronze",
  bronze: "silver",
  silver: "gold",
  gold: "platinum",
  platinum: "diamond",
  diamond: "master",
  master: "",
}

export const SEASON_REWARDS = {
  iron: ["Iron Icon", "Iron Banner Trim", "Eternal Series 1"],
  bronze: ["Bronze Icon", "Bronze Banner Trim", "Eternal Series 1"],
  silver: [
    "Silver Icon",
    "Silver Banner Trim",
    "Silver Border",
    "Eternal Series 1",
  ],
  gold: [
    "Gold Icon",
    "Gold Banner Trim",
    "Gold Border",
    "Eternal Series 1",
    "Victorious Champion & Skin",
    "Victorious Chroma (up to)",
  ],
  platinum: [
    "Platinum Icon",
    "Platinum Banner Trim",
    "Platinum Border",
    "Eternal Series 1",
    "Victorious Champion & Skin",
    "Victorious Chroma (up to)",
  ],
  diamond: [
    "Diamond Icon",
    "Diamond Banner Trim",
    "Diamond Border",
    "Eternal Series 1",
    "Victorious Champion & Skin",
    "Victorious Chroma (up to)",
  ],
  master: [
    "Master Icon",
    "Master Banner Trim",
    "Master Border",
    "Eternal Series 1",
    "Victorious Champion & Skin",
    "Victorious Chroma (up to)",
  ],
}

export const ONBOARDING_RANK_ICONS = {
  Iron: ironOnboardingThumbnail,
  Bronze: bronzeOnboardingThumbnail,
  Silver: silverOnboardingThumbnail,
  Gold: goldOnboardingThumbnail,
  Platinum: platinumOnboardingThumbnail,
  Diamond: diamondOnboardingThumbnail,
  Master: masterOnboardingThumbnail,
}

export const SPECIALIZATIONS = {
  top,
  mid,
  jungle,
  ad: bot,
  support,
}



// WEBPACK FOOTER //
// ./src/constants/league_of_legends.js